import {
  Box,
  Button,
  MenuItem,
  Paper,
  Select,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import api from "../../API";
import { useSelector } from "react-redux";
import { SearchBackDrop } from "../component/common/SearchBackDrop";
import CustomPagination from "../component/common/CustomPagination";
import SsbJsonDialog from "./SsbJsonDialog";


const ispChecklistDef = [
  { key:'difficulty_result',  label:'난이도 분류 정확성', isParent:false, indent:false, height:72, groupHeader:'난이도 분류 정확성', groupColor:'#7b4fce', groupBg:'#faf7ff', groupHeaderBg:'#ebe0ff' },
  { key:'question_1_result',  label:'문법표현',           isParent:false, indent:false, height:72, groupHeader:'질문적정성',         groupColor:'#1a6bb5', groupBg:'#f5f9ff', groupHeaderBg:'#d6eaff' },
  { key:'question_2_result',  label:'Red/Benign',         isParent:false, indent:false, height:72,                                   groupColor:'#1a6bb5', groupBg:'#f5f9ff', groupHeaderBg:'#d6eaff' },
  { key:'question_3_result',  label:'트랙형식',           isParent:false, indent:false, height:72,                                   groupColor:'#1a6bb5', groupBg:'#f5f9ff', groupHeaderBg:'#d6eaff' },
  { key:'question_4_result',  label:'트랙내용',           isParent:false, indent:false, height:72,                                   groupColor:'#1a6bb5', groupBg:'#f5f9ff', groupHeaderBg:'#d6eaff' },
  { key:'rationale_1_result', label:'필수요소',           isParent:false, indent:false, height:72, groupHeader:'판정근거적정성',     groupColor:'#0077a8', groupBg:'#f2faff', groupHeaderBg:'#c8eaf7' },
  { key:'rationale_2_result', label:'정답설정근거',       isParent:false, indent:false, height:72,                                   groupColor:'#0077a8', groupBg:'#f2faff', groupHeaderBg:'#c8eaf7' },
  { key:'rationale_3_result', label:'선택지근거',         isParent:false, indent:false, height:72,                                   groupColor:'#0077a8', groupBg:'#f2faff', groupHeaderBg:'#c8eaf7' },
  { key:'rationale_4_result', label:'체크포인트',         isParent:false, indent:false, height:72,                                   groupColor:'#0077a8', groupBg:'#f2faff', groupHeaderBg:'#c8eaf7' },
  { key:'claude_result',      label:'Claude 답변',        isParent:false, indent:false, height:72, groupHeader:'AI 답변 평가',       groupColor:'#b85c00', groupBg:'#fff8f0', groupHeaderBg:'#ffe4c0' },
  { key:'gemini_result',      label:'Gemini 답변',        isParent:false, indent:false, height:72,                                   groupColor:'#b85c00', groupBg:'#fff8f0', groupHeaderBg:'#ffe4c0' },
  { key:'gpt_result',         label:'GPT 답변',           isParent:false, indent:false, height:72,                                   groupColor:'#b85c00', groupBg:'#fff8f0', groupHeaderBg:'#ffe4c0' },
];

// result_tf 순서: domain(hidden,1) | difficulty(2) | question1~4(3~6) | rationale1~4(7~10) | claude(11) | gemini(12) | gpt(13)
const ISP_KEYS = [
  'difficulty_result',
  'question_1_result', 'question_2_result', 'question_3_result', 'question_4_result',
  'rationale_1_result', 'rationale_2_result', 'rationale_3_result', 'rationale_4_result',
  'claude_result', 'gemini_result', 'gpt_result',
];

const initIspChecklist: {[key:string]:string} = {
  difficulty_result:'PASS',
  question_1_result:'PASS', question_2_result:'PASS', question_3_result:'PASS', question_4_result:'PASS',
  rationale_1_result:'PASS', rationale_2_result:'PASS', rationale_3_result:'PASS', rationale_4_result:'PASS',
  claude_result:'PASS', gemini_result:'PASS', gpt_result:'PASS',
};

const initIspReasons: {[key:string]:string} = {
  difficulty_result:'',
  question_1_result:'', question_2_result:'', question_3_result:'', question_4_result:'',
  rationale_1_result:'', rationale_2_result:'', rationale_3_result:'', rationale_4_result:'',
  claude_result:'', gemini_result:'', gpt_result:'',
};


export interface pageInfoType {
  current_page: number;
  total_pages: number;
}

const IspEssWorkerPage = (props: any) => {

  const [openJsonDialog, setOpenJsonDialog] = useState<boolean>(false)
  const [page, setPage] = useState(1);
  const [c_page, setC_page] = useState("")
  const [order, setOrder] = useState('desc');
  const [total_cnt, setTotal_cnt] = useState(0);
  const [pagination, setPagination] = useState<pageInfoType | undefined>(undefined);
  const [ssbWorkList, setSsbWorkList] = useState([]);
  const [job_yn_filter, setJob_yn_filter] = useState('모두');
  const [track_filter, setTrack_filter] = useState('모두');
  const [summaryInfo, setSummaryInfo] = useState({total: 0, y_count: 0, n_count: 0});
  const [backdrop, setBackdrop] = useState<boolean>(false)
  const [metaOpen, setMetaOpen] = useState(false);

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;
  const worker = useSelector((state:any)=> state.userInfo.data.user.user_id)

  const [ssbData, setSsbData] = useState<any>({});
  const [ispChecklist, setIspChecklist] = useState<{[key:string]:string}>(initIspChecklist);
  const [ispReasons, setIspReasons] = useState<{[key:string]:string}>(initIspReasons);

  const hasIspFailItem = ISP_KEYS.some(k => ispChecklist[k] === 'FAIL');

  useEffect(() => {
    const toResult = (val: string) => val === 'FAIL' ? 'FAIL' : 'PASS';
    setIspChecklist({
      difficulty_result:  toResult(ssbData.difficulty_result  || ''),
      question_1_result:  toResult(ssbData.question_1_result  || ''),
      question_2_result:  toResult(ssbData.question_2_result  || ''),
      question_3_result:  toResult(ssbData.question_3_result  || ''),
      question_4_result:  toResult(ssbData.question_4_result  || ''),
      rationale_1_result: toResult(ssbData.rationale_1_result || ''),
      rationale_2_result: toResult(ssbData.rationale_2_result || ''),
      rationale_3_result: toResult(ssbData.rationale_3_result || ''),
      rationale_4_result: toResult(ssbData.rationale_4_result || ''),
      claude_result:      toResult(ssbData.claude_result      || ''),
      gemini_result:      toResult(ssbData.gemini_result      || ''),
      gpt_result:         toResult(ssbData.gpt_result         || ''),
    });
    setIspReasons({
      difficulty_result:  ssbData.difficulty_reason  || '',
      question_1_result:  ssbData.question_1_reason  || '',
      question_2_result:  ssbData.question_2_reason  || '',
      question_3_result:  ssbData.question_3_reason  || '',
      question_4_result:  ssbData.question_4_reason  || '',
      rationale_1_result: ssbData.rationale_1_reason || '',
      rationale_2_result: ssbData.rationale_2_reason || '',
      rationale_3_result: ssbData.rationale_3_reason || '',
      rationale_4_result: ssbData.rationale_4_reason || '',
      claude_result:      ssbData.claude_reason      || '',
      gemini_result:      ssbData.gemini_reason      || '',
      gpt_result:         ssbData.gpt_reason         || '',
    });
  }, [ssbData.idx]);

  const handleSave = (job_yn: string) => {
    if (!ssbData.idx) return;
    setBackdrop(true);

    const toTF = (val: string) => val === 'PASS' ? 'T' : 'F';
    // prc_checklist 13자리 → anna_result_ess.result_tf_isp 에 저장
    // result_tf (DB 초기값) 는 건드리지 않음
    const prc_checklist = [
      toTF(ssbData.domain_result || ''),       // pos 1: domain (UI 제외)
      toTF(ispChecklist.difficulty_result),    // pos 2
      toTF(ispChecklist.question_1_result),    // pos 3
      toTF(ispChecklist.question_2_result),    // pos 4
      toTF(ispChecklist.question_3_result),    // pos 5
      toTF(ispChecklist.question_4_result),    // pos 6
      toTF(ispChecklist.rationale_1_result),   // pos 7
      toTF(ispChecklist.rationale_2_result),   // pos 8
      toTF(ispChecklist.rationale_3_result),   // pos 9
      toTF(ispChecklist.rationale_4_result),   // pos 10
      toTF(ispChecklist.claude_result),         // pos 11
      toTF(ispChecklist.gemini_result),         // pos 12
      toTF(ispChecklist.gpt_result),            // pos 13
    ].join('');

    api.post('/updateSsbIspEssData', {
      ...ssbData,
      email,
      job_yn,
      prc_checklist,
      difficulty_result:  ispChecklist.difficulty_result,
      difficulty_reason:  ispReasons.difficulty_result,
      question_1_result:  ispChecklist.question_1_result,
      question_1_reason:  ispReasons.question_1_result,
      question_2_result:  ispChecklist.question_2_result,
      question_2_reason:  ispReasons.question_2_result,
      question_3_result:  ispChecklist.question_3_result,
      question_3_reason:  ispReasons.question_3_result,
      question_4_result:  ispChecklist.question_4_result,
      question_4_reason:  ispReasons.question_4_result,
      rationale_1_result: ispChecklist.rationale_1_result,
      rationale_1_reason: ispReasons.rationale_1_result,
      rationale_2_result: ispChecklist.rationale_2_result,
      rationale_2_reason: ispReasons.rationale_2_result,
      rationale_3_result: ispChecklist.rationale_3_result,
      rationale_3_reason: ispReasons.rationale_3_result,
      rationale_4_result: ispChecklist.rationale_4_result,
      rationale_4_reason: ispReasons.rationale_4_result,
      claude_result:      ispChecklist.claude_result,
      claude_reason:      ispReasons.claude_result,
      gemini_result:      ispChecklist.gemini_result,
      gemini_reason:      ispReasons.gemini_result,
      gpt_result:         ispChecklist.gpt_result,
      gpt_reason:         ispReasons.gpt_result,
    })
    .then(() => {
      setBackdrop(false);
      alert(`${ssbData.bmk_id} ${job_yn === 'Y' ? '수정하였습니다' : '부적합 처리하였습니다'}`);
      getSummary();
      getSsbDataList();
    })
    .catch((error:any) => {
      console.error('저장 오류', error?.response);
      setBackdrop(false);
    });
  };

  const goPage = (clickPage: any) => { setPage(clickPage); };

  const getSummary = () => {
    api.get('/ssbIspEssSummary', {params: {worker}})
      .then((res: any) => setSummaryInfo(res.data))
      .catch(() => {});
  };

  const getSsbDataList = async (selectFirst: boolean = false) => {
    setBackdrop(true);
    api.get('/ssbIspEssDataList', {params:{email, worker, page, order, job_yn: job_yn_filter, track: track_filter, idx:""}})
    .then((res:any) => {
      if (res.data.datas.length > 0) {
        setSsbWorkList(res.data.datas);
        if (selectFirst) {
          setSsbData(res.data.datas[0]);
        } else if ((ssbData && ssbData.idx == null) || (pagination && page !== pagination.current_page)) {
          setSsbData(res.data.datas[0]);
        }
        setPagination(res.data.pagination);
        setTotal_cnt(res.data.pagination.total_count);
      } else {
        setSsbWorkList(res.data.datas);
        setPagination(res.data.pagination);
        setTotal_cnt(0);
      }
      setBackdrop(false);
    })
    .catch((error:any) => { console.error('에러', error.response); setBackdrop(false); });
  };

  useEffect(() => { getSummary(); }, []);
  useEffect(() => { getSsbDataList(); }, [page, props.rowDetail, job_yn_filter, track_filter]);


  return (
    <Paper sx={{width:"100%", overflow:"auto"}}>
      {backdrop && (<SearchBackDrop message={"처리중..."} />)}
      <Box sx={{margin:"1px 20px 0px 20px", fontWeight:700, fontSize:"24px", letterSpacing:"-2px"}}>사회적 안전성(검수-서술형)</Box>
      <hr style={{borderTop:"2px solid #3e36a5", marginTop:"0px"}} />
      <Box display="flex">

        {/* 본문 영역 */}
        <Box display="flex">
          <Box sx={{width:"100%"}}>
            <Paper sx={{padding:"2px", border:"3px solid #3e36a5", backgroundColor:"#e8f4ff"}}>
              <Box sx={{margin:"2px"}}>

                {/* 제목 + JSON */}
                <Box sx={{display:"flex", justifyContent:"center", alignItems:"center", marginBottom:"8px"}}>
                  <Box sx={{fontSize:"18px", fontWeight:700, textAlign:"center", margin:"2px"}}>{ssbData.track} - {ssbData.bmk_id}</Box>
                  <Button variant="contained" size="small" sx={{marginLeft:"32px", fontWeight:700, backgroundColor:"#e79055"}} onClick={() => setOpenJsonDialog(true)}>
                    OPEN JSON
                  </Button>
                </Box>
                {openJsonDialog && <SsbJsonDialog className="json-dialog-content" data={ssbData.submission_json} setOpenJsonDialog={setOpenJsonDialog} />}

                {/* 메타데이터 */}
                <Box sx={{border:"1.5px solid #9090c8", borderRadius:"8px", overflow:"hidden"}}>
                  <Box
                    onClick={() => setMetaOpen(prev => !prev)}
                    sx={{
                      display:"flex", alignItems:"flex-start", gap:"6px",
                      padding:"5px 12px", cursor:"pointer",
                      backgroundColor: metaOpen ? "#6c66c0" : "#3e36a5",
                      userSelect:"none", "&:hover":{backgroundColor:"#3e36a5"},
                    }}
                  >
                    <Box sx={{color:"#fff", fontSize:"12px", fontWeight:700, letterSpacing:"0.8px", flexShrink:0, paddingTop:"2px"}}>METADATA</Box>
                    <Box sx={{display:"flex", flexDirection:"column", gap:"3px", marginLeft:"10px", flex:1}}>
                      <Box sx={{display:"flex", gap:"4px", flexWrap:"wrap"}}>
                        {([
                          {label:"TRACK",    value: ssbData.track,     bg:"#000"},
                          {label:"BMK_ID",   value: ssbData.bmk_id,    bg:"#000"},
                          {label:"SOURCE_ID",value: ssbData.source_id, bg:"#000"},
                        ] as {label:string; value:any; bg:string}[]).map(item => (
                          <Box key={item.label} sx={{display:"flex", alignItems:"center", border:"1px solid #9090c8", borderRadius:"4px", overflow:"hidden", flexShrink:0}}>
                            <Box sx={{backgroundColor:item.bg, color:"#fff", fontSize:"10px", fontWeight:700, padding:"2px 6px"}}>{item.label}</Box>
                            <Box sx={{backgroundColor:"#fff", fontSize:"12px", padding:"2px 8px", minWidth:"30px", maxWidth:"200px", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", fontFamily:"Noto Sans KR"}}>{String(item.value ?? "")}</Box>
                          </Box>
                        ))}
                        {(() => {
                          try {
                            const sub = typeof ssbData.submission_json === 'string' ? JSON.parse(ssbData.submission_json) : ssbData.submission_json;
                            const or = sub?.over_refusal?.[0] ?? sub?.over_refusal;
                            if (!or) return null;
                            const isRed = String(or.over_refusal_type ?? '').toLowerCase() === 'red';
                            const baseColor = isRed ? '#c0392b' : '#2563b0';
                            const baseBorder = isRed ? '#e08080' : '#8090d0';
                            const baseBg    = isRed ? '#fff8f8' : '#f4f7ff';
                            const benignVal = String(or.benign_state ?? '').toLowerCase();
                            const benignIsNone = benignVal === '' || benignVal === 'none' || benignVal === 'null';
                            const benignColor  = benignIsNone ? baseColor  : '#27a348';
                            const benignBorder = benignIsNone ? baseBorder : '#80c8a0';
                            const benignBg     = benignIsNone ? baseBg     : '#f4fff8';
                            return (
                              <>
                                <Box sx={{display:"flex", alignItems:"center", border:`1px solid ${baseBorder}`, borderRadius:"4px", overflow:"hidden", flexShrink:0}}>
                                  <Box sx={{backgroundColor:baseColor, color:"#fff", fontSize:"10px", fontWeight:700, padding:"2px 6px"}}>OVER_REFUSAL_TYPE</Box>
                                  <Box sx={{backgroundColor:baseBg, fontSize:"12px", padding:"2px 8px", minWidth:"30px", maxWidth:"200px", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", fontFamily:"Noto Sans KR", color:baseColor, fontWeight:700}}>{String(or.over_refusal_type ?? "")}</Box>
                                </Box>
                                <Box sx={{display:"flex", alignItems:"center", border:`1px solid ${benignBorder}`, borderRadius:"4px", overflow:"hidden", flexShrink:0}}>
                                  <Box sx={{backgroundColor:benignColor, color:"#fff", fontSize:"10px", fontWeight:700, padding:"2px 6px"}}>BENIGN_STATE</Box>
                                  <Box sx={{backgroundColor:benignBg, fontSize:"12px", padding:"2px 8px", minWidth:"30px", maxWidth:"200px", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", fontFamily:"Noto Sans KR", color:benignColor, fontWeight:700}}>{String(or.benign_state ?? "")}</Box>
                                </Box>
                              </>
                            );
                          } catch { return null; }
                        })()}
                      </Box>
                      <Box sx={{display:"flex", gap:"4px"}}>
                        {([
                          {label:"도메인코드", value: ssbData.domain_cd,  bg:"#2d7a4f"},
                          {label:"도메인",     value: ssbData.domain,     bg:"#2d7a4f"},
                          {label:"서브도메인", value: ssbData.subdomain,  bg:"#2d7a4f"},
                          {label:"DIFFICULTY", value: ssbData.difficulty, bg:"#7a4f2d"},
                        ] as {label:string; value:any; bg:string}[]).map(item => (
                          <Box key={item.label} sx={{display:"flex", alignItems:"center", border:"1px solid #9090c8", borderRadius:"4px", overflow:"hidden", flexShrink:0}}>
                            <Box sx={{backgroundColor:item.bg, color:"#fff", fontSize:"10px", fontWeight:700, padding:"2px 6px"}}>{item.label}</Box>
                            <Box sx={{backgroundColor:"#fff", fontSize:"12px", padding:"2px 8px", minWidth:"30px", maxWidth:"300px", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", fontFamily:"Noto Sans KR"}}>{String(item.value ?? "")}</Box>
                          </Box>
                        ))}
                      </Box>
                    </Box>
                    <Box sx={{color:"#ccd", fontSize:"11px", marginLeft:"auto", flexShrink:0, paddingTop:"2px"}}>{metaOpen ? "▲" : "▼"}</Box>
                  </Box>

                  {metaOpen && (
                    <Box sx={{backgroundColor:"#f4f4ff", padding:"10px", display:"flex", flexDirection:"column", gap:"6px"}}>
                      <Box sx={{display:"flex", flexWrap:"wrap", gap:"6px"}}>
                        {([
                          {label:"IDX",       value: ssbData.idx,       bg:"#3e36a5"},
                          {label:"TRACK",     value: ssbData.track,     bg:"#3e36a5"},
                          {label:"BMK_ID",    value: ssbData.bmk_id,    bg:"#3e36a5"},
                          {label:"SOURCE_ID", value: ssbData.source_id, bg:"#3e36a5"},
                        ] as {label:string; value:any; bg:string}[]).map(item => (
                          <Box key={item.label} sx={{display:"flex", alignItems:"center", border:"1px solid #9090c8", borderRadius:"4px", overflow:"hidden"}}>
                            <Box sx={{backgroundColor:item.bg, color:"#fff", fontSize:"10px", fontWeight:700, padding:"2px 6px"}}>{item.label}</Box>
                            <Box sx={{backgroundColor:"#fff", fontSize:"12px", padding:"2px 8px", minWidth:"30px", fontFamily:"Noto Sans KR"}}>{String(item.value ?? "")}</Box>
                          </Box>
                        ))}
                      </Box>
                      <Box sx={{display:"flex", flexWrap:"wrap", gap:"6px"}}>
                        {([
                          {label:"ITEM_TYPE",     value: ssbData.item_type,     bg:"#7a4f2d"},
                          {label:"DIFFICULTY",    value: ssbData.difficulty,    bg:"#7a4f2d"},
                          {label:"WORD_COUNT",    value: ssbData.word_count,    bg:"#7a4f2d"},
                          {label:"DIALOGUE_TYPE", value: ssbData.dialogue_type, bg:"#7a4f2d"},
                          {label:"TURN_COUNT",    value: ssbData.turn_count,    bg:"#7a4f2d"},
                        ] as {label:string; value:any; bg:string}[]).map(item => (
                          <Box key={item.label} sx={{display:"flex", alignItems:"center", border:"1px solid #9090c8", borderRadius:"4px", overflow:"hidden"}}>
                            <Box sx={{backgroundColor:item.bg, color:"#fff", fontSize:"10px", fontWeight:700, padding:"2px 6px"}}>{item.label}</Box>
                            <Box sx={{backgroundColor:"#fff", fontSize:"12px", padding:"2px 8px", minWidth:"30px", fontFamily:"Noto Sans KR"}}>{String(item.value ?? "")}</Box>
                          </Box>
                        ))}
                      </Box>
                      <Box sx={{display:"flex", flexWrap:"wrap", gap:"6px"}}>
                        {([
                          {label:"WORKER",   value: ssbData.worker,   bg:"#6d2d7a"},
                          {label:"JOB_YN",   value: ssbData.job_yn,   bg:"#6d2d7a"},
                          {label:"ISP_YN",   value: ssbData.isp_yn,   bg:"#6d2d7a"},
                          {label:"INS_DATE", value: ssbData.ins_date, bg:"#6d2d7a"},
                          {label:"JOB_DATE", value: ssbData.job_date, bg:"#6d2d7a"},
                        ] as {label:string; value:any; bg:string}[]).map(item => (
                          <Box key={item.label} sx={{display:"flex", alignItems:"center", border:"1px solid #9090c8", borderRadius:"4px", overflow:"hidden"}}>
                            <Box sx={{backgroundColor:item.bg, color:"#fff", fontSize:"10px", fontWeight:700, padding:"2px 6px"}}>{item.label}</Box>
                            <Box sx={{backgroundColor:"#fff", fontSize:"12px", padding:"2px 8px", minWidth:"30px", fontFamily:"Noto Sans KR"}}>{String(item.value ?? "")}</Box>
                          </Box>
                        ))}
                      </Box>
                    </Box>
                  )}
                </Box>

              </Box>

              {/* 본문 텍스트 */}
              <Box sx={{margin:"4px 2px"}}>
                <Box sx={{margin:"0px 0px 0px 2px", color:"#3e36a5", fontWeight:700}}>System-prompt</Box>
                <textarea spellCheck={false} value={ssbData.pt_system || ""} onChange={(e) => setSsbData({...ssbData, pt_system: e.target.value})} style={{border:"4px solid #000", width:"100%", minHeight:"90px", height:"90px", fontSize:"14px", padding:"2px", fontFamily:"Noto Sans KR", boxSizing:"border-box"}} />
              </Box>
              <Box sx={{margin:"4px 2px"}}>
                <Box sx={{margin:"0px 0px 0px 2px", color:"#3e36a5", fontWeight:700}}>
                  Content (난이도: <b style={{fontSize:"13px", fontWeight:700, color: ssbData.difficulty === "high" ? "red" : ssbData.difficulty === "medium" ? "#d76800" : "#00db45"}}>{ssbData.difficulty === "high" ? "High" : ssbData.difficulty === "medium" ? "Medium" : "Low"}</b>)
                </Box>
                {(() => {
                  let arr: any[] | null = null;
                  try {
                    const parsed = typeof ssbData.content === 'string' ? JSON.parse(ssbData.content) : ssbData.content;
                    if (Array.isArray(parsed)) arr = parsed;
                  } catch {}

                  let expectedArr: any[] = [];
                  try {
                    const er = ssbData.expected_responses;
                    const parsed = typeof er === 'string' ? JSON.parse(er) : er;
                    if (Array.isArray(parsed)) expectedArr = parsed;
                  } catch {}

                  const roleStyles: {[key:string]: {color:string; bg:string}} = {
                    user:      {color:'#1a5fa8', bg:'#eaf3ff'},
                    human:     {color:'#1a5fa8', bg:'#eaf3ff'},
                    assistant: {color:'#6d2d7a', bg:'#f9f0ff'},
                    system:    {color:'#3e36a5', bg:'#f0f0ff'},
                  };

                  return (
                    // ↓ 높이 조절: height 값을 변경하세요
                    <Box sx={{border:"4px solid #000", width:"100%", height:"420px", overflowY:"auto", padding:"4px", fontFamily:"Noto Sans KR", boxSizing:"border-box", backgroundColor:"#fff"}}>
                      {arr ? (
                        arr.map((item: any, i: number) => {
                          const roleKey = String(item?.role ?? '').toLowerCase();
                          const rs = roleStyles[roleKey] ?? {color:'#555', bg:'#f5f5f5'};
                          const contentText = typeof item === 'object'
                            ? String(item.content ?? item.text ?? JSON.stringify(item))
                            : String(item);
                          const expected = expectedArr[i];
                          const expectedText = expected == null ? null
                            : typeof expected === 'string' ? expected
                            : (expected?.content != null ? String(expected.content) : JSON.stringify(expected, null, 2));
                          return (
                            <Box key={i} sx={{border:`1px solid ${rs.color}30`, borderRadius:"6px", marginBottom:"6px", overflow:"hidden"}}>
                              <Box sx={{display:"flex", alignItems:"center", gap:"6px", padding:"3px 8px", backgroundColor:rs.bg, borderBottom:`1px solid ${rs.color}25`}}>
                                <Box sx={{fontSize:"10px", fontWeight:800, color:rs.color, letterSpacing:"0.8px", padding:"1px 6px", borderRadius:"3px", border:`1px solid ${rs.color}60`, backgroundColor:"#fff"}}>{roleKey.toUpperCase() || `TURN ${i+1}`}</Box>
                                <Box sx={{fontSize:"10px", color:"#aaa"}}>#{i + 1}</Box>
                              </Box>
                              <Box sx={{padding:"6px 10px", fontSize:"13px", fontWeight:700, lineHeight:"1.7", whiteSpace:"pre-wrap", wordBreak:"break-word", color:"#333", backgroundColor:rs.bg + "66"}}>
                                {contentText}
                              </Box>
                              {expectedText != null && (
                                <>
                                  <Box sx={{display:"flex", alignItems:"center", gap:"6px", padding:"3px 8px", backgroundColor:"#e8fff0", borderTop:"1px solid #27a34830", borderBottom:"1px solid #27a34820"}}>
                                    <Box sx={{fontSize:"10px", fontWeight:800, color:"#27a348", letterSpacing:"0.8px", padding:"1px 6px", borderRadius:"3px", border:"1px solid #27a34860", backgroundColor:"#fff"}}>EXPECTED</Box>
                                  </Box>
                                  <Box sx={{padding:"6px 10px", fontSize:"13px", lineHeight:"1.7", whiteSpace:"pre-wrap", wordBreak:"break-word", color:"#000", backgroundColor:"#d3ffe4"}}>
                                    {expectedText}
                                  </Box>
                                </>
                              )}
                            </Box>
                          );
                        })
                      ) : (
                        <Box sx={{border:"1px solid #ccc", borderRadius:"6px", overflow:"hidden"}}>
                          <Box sx={{display:"flex", alignItems:"center", gap:"6px", padding:"3px 8px", backgroundColor:"#f5f5f5", borderBottom:"1px solid #e0e0e0"}}>
                            <Box sx={{fontSize:"10px", fontWeight:800, color:"#555", letterSpacing:"0.8px", padding:"1px 6px", borderRadius:"3px", border:"1px solid #ccc", backgroundColor:"#fff"}}>CONTENT</Box>
                          </Box>
                          <Box sx={{padding:"6px 10px", fontSize:"13px", fontWeight:700, lineHeight:"1.7", whiteSpace:"pre-wrap", wordBreak:"break-word", color:"#333", backgroundColor:"#fafafa"}}>
                            {ssbData.content || ""}
                          </Box>
                          {expectedArr.length > 0 && (
                            <>
                              <Box sx={{display:"flex", alignItems:"center", gap:"6px", padding:"3px 8px", backgroundColor:"#e8fff0", borderTop:"1px solid #27a34830", borderBottom:"1px solid #27a34820"}}>
                                <Box sx={{fontSize:"10px", fontWeight:800, color:"#27a348", letterSpacing:"0.8px", padding:"1px 6px", borderRadius:"3px", border:"1px solid #27a34860", backgroundColor:"#fff"}}>EXPECTED</Box>
                              </Box>
                              <Box sx={{padding:"6px 10px", fontSize:"13px", lineHeight:"1.7", whiteSpace:"pre-wrap", wordBreak:"break-word", color:"#000", backgroundColor:"#d3ffe4"}}>
                                {expectedArr.map((e: any, i: number) => {
                                  const t = typeof e === 'string' ? e : (e?.content != null ? String(e.content) : JSON.stringify(e, null, 2));
                                  return <Box key={i} sx={{marginBottom: i < expectedArr.length - 1 ? "8px" : 0}}>{t}</Box>;
                                })}
                              </Box>
                            </>
                          )}
                        </Box>
                      )}
                    </Box>
                  );
                })()}
              </Box>

              {/* Key Requirements */}
              <Box sx={{margin:"8px 2px 4px 2px"}}>
                <Box sx={{margin:"0px 0px 6px 2px", color:"#3e36a5", fontWeight:700, fontSize:"13px", letterSpacing:"0.3px"}}>Key Requirements</Box>
                {(() => {
                  const raw = ssbData.key_requirements;
                  if (!raw) return <Box sx={{fontSize:"13px", color:"#bbb", fontStyle:"italic", padding:"6px 0"}}>없음</Box>;
                  try {
                    const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
                    if (Array.isArray(parsed)) {
                      return (
                        <Box sx={{display:"flex", flexDirection:"column", gap:"4px"}}>
                          {parsed.map((item: any, i: number) => (
                            <Box key={i} sx={{display:"flex", gap:"8px", alignItems:"flex-start", padding:"6px 10px", borderRadius:"6px", backgroundColor:"#f0f4ff", border:"1px solid #c0c8f0"}}>
                              <Box sx={{flexShrink:0, width:"20px", height:"20px", borderRadius:"50%", backgroundColor:"#3e36a5", color:"#fff", fontSize:"11px", fontWeight:700, display:"flex", alignItems:"center", justifyContent:"center"}}>{i + 1}</Box>
                              <Box sx={{fontSize:"13px", fontWeight:700, lineHeight:"1.6", color:"#333", fontFamily:"Noto Sans KR", whiteSpace:"pre-wrap", wordBreak:"break-word", flex:1}}>{typeof item === 'string' ? item : JSON.stringify(item, null, 2)}</Box>
                            </Box>
                          ))}
                        </Box>
                      );
                    }
                    if (typeof parsed === 'object') {
                      return (
                        <Box component="pre" sx={{margin:0, padding:"8px 12px", borderRadius:"6px", backgroundColor:"#f8f8ff", border:"1px solid #c0c8f0", fontSize:"12px", fontFamily:"monospace", lineHeight:"1.5", overflowX:"auto", whiteSpace:"pre-wrap", wordBreak:"break-word"}}>
                          {JSON.stringify(parsed, null, 2)}
                        </Box>
                      );
                    }
                  } catch {}
                  return (
                    <Box sx={{padding:"8px 10px", borderRadius:"6px", backgroundColor:"#f0f4ff", border:"1px solid #c0c8f0", fontSize:"13px", fontWeight:700, lineHeight:"1.7", color:"#333", fontFamily:"Noto Sans KR", whiteSpace:"pre-wrap", wordBreak:"break-word"}}>
                      {String(raw)}
                    </Box>
                  );
                })()}
              </Box>

            </Paper>
          </Box>
        </Box>

        {/* 체크리스트 */}
        <Box sx={{
          marginLeft:"2px", position:"sticky", top:0,
          height:"calc(100vh + 50px)", display:"flex", flexDirection:"column",
          paddingTop:"12px", paddingBottom:"12px", boxSizing:"border-box",
        }}>

          {/* 요약 스탯 카드 */}
          <Box sx={{display:"flex", gap:"6px", marginBottom:"8px", width:"600px", flexShrink:0}}>
            {([
              {label:"총",    value: summaryInfo.total,                                            color:"#3e36a5", bg:"#f0f0ff", border:"#9090c8"},
              {label:"적합",  value: summaryInfo.y_count,                                          color:"#27a348", bg:"#f0fff4", border:"#a8ddb5"},
              {label:"부적합",value: summaryInfo.n_count,                                          color:"#c0392b", bg:"#fff0ee", border:"#f0b0a8"},
              {label:"미작업",value: summaryInfo.total - summaryInfo.y_count - summaryInfo.n_count, color:"#888",    bg:"#f5f5f5", border:"#ccc"},
            ] as {label:string; value:number; color:string; bg:string; border:string}[]).map(item => (
              <Box key={item.label} sx={{flex:1, padding:"5px 10px", border:`1.5px solid ${item.border}`, borderRadius:"8px", backgroundColor:item.bg, display:"flex", alignItems:"center", gap:"8px"}}>
                <Box sx={{fontSize:"11px", fontWeight:600, color:"#999"}}>{item.label}</Box>
                <Box sx={{display:"flex", alignItems:"baseline", gap:"2px"}}>
                  <Box sx={{fontSize:"20px", fontWeight:800, color:item.color, lineHeight:1}}>{item.value}</Box>
                  <Box sx={{fontSize:"11px", fontWeight:600, color:item.color}}>건</Box>
                </Box>
              </Box>
            ))}
          </Box>

          <Box sx={{width:"600px", minWidth:"600px", border:"1.5px solid #c8c8e8", borderRadius:"10px", overflow:"hidden", boxShadow:"0 2px 12px rgba(62,54,165,0.10)", flex:1, display:"flex", flexDirection:"column"}}>
            {/* 헤더 */}
            <Box sx={{padding:"9px 14px", background:"linear-gradient(90deg, #2d8c50 0%, #3ba35c 100%)", display:"flex", alignItems:"center"}}>
              <Box sx={{color:"#fff", fontSize:"12px", fontWeight:700, letterSpacing:"0.8px"}}>검수 체크리스트</Box>
              {hasIspFailItem && (
                <Box sx={{marginLeft:"auto", fontSize:"10px", fontWeight:700, color:"#ffcccc", backgroundColor:"rgba(255,255,255,0.18)", padding:"2px 9px", borderRadius:"10px", letterSpacing:"0.3px"}}>FAIL 항목 있음</Box>
              )}
            </Box>

            <Box sx={{backgroundColor:"#fff", overflowY:"auto", flex:1}}>
              {ispChecklistDef.map((item, i) => {
                const isFail = ispChecklist[item.key] === 'FAIL';
                const gc  = (item as any).groupColor    || '#888';
                const gb  = (item as any).groupBg       || '#fff';
                const ghb = (item as any).groupHeaderBg || '#eee';
                const isFirst = i === 0;
                return (
                  <React.Fragment key={item.key}>
                    {(item as any).groupHeader && (
                      <Box sx={{padding:"5px 12px", borderLeft:`4px solid ${gc}`, borderTop: isFirst ? "none" : `2px solid ${gc}`, borderBottom:`1px solid ${gc}40`, backgroundColor:ghb, display:"flex", alignItems:"center", gap:"6px"}}>
                        <Box sx={{width:"6px", height:"6px", borderRadius:"50%", backgroundColor:gc, flexShrink:0}} />
                        <Box sx={{fontSize:"11px", fontWeight:800, color:gc, letterSpacing:"0.5px"}}>{(item as any).groupHeader}</Box>
                      </Box>
                    )}
                    <Box sx={{borderBottom: i < ispChecklistDef.length - 1 ? `1px solid ${gc}25` : "none", borderLeft:`3px solid ${isFail ? "#c0392b" : gc}`, padding:"5px 10px", backgroundColor: isFail ? "#fff4f4" : gb}}>
                      <Box sx={{display:"flex", justifyContent:"space-between", alignItems:"center", gap:"6px", marginBottom:"3px"}}>
                        <Box sx={{fontSize:"11px", fontWeight:700, color: isFail ? "#c0392b" : "#444", flex:1}}>{item.label}</Box>
                        <Box sx={{display:"flex", gap:"3px", flexShrink:0}}>
                          {(['PASS','FAIL'] as const).map(val => {
                            const isSelected = ispChecklist[item.key] === val;
                            const isPass = val === 'PASS';
                            return (
                              <Box key={val} component="label" sx={{display:"flex", alignItems:"center", padding:"1px 8px", borderRadius:"10px", cursor:"pointer", fontSize:"10px", fontWeight:700, letterSpacing:"0.3px", backgroundColor: isSelected ? (isPass ? "#27a348" : "#c0392b") : "transparent", color: isSelected ? "#fff" : (isPass ? "#27a348" : "#c0392b"), border:`1.5px solid ${isPass ? "#27a348" : "#c0392b"}`, userSelect:"none", transition:"background-color 0.12s, color 0.12s"}}>
                                <input type="radio" name={`${item.key}_${ssbData.idx}`} value={val} checked={isSelected} onChange={() => setIspChecklist(prev => ({...prev, [item.key]: val}))} style={{display:"none"}} />
                                {val}
                              </Box>
                            );
                          })}
                        </Box>
                      </Box>
                      <textarea
                        spellCheck={false}
                        value={ispReasons[item.key] || ''}
                        onChange={(e) => setIspReasons(prev => ({...prev, [item.key]: e.target.value}))}
                        placeholder="사유"
                        style={{width:"100%", boxSizing:"border-box", resize:"vertical", fontSize:"13px", padding:"4px 7px", borderRadius:"4px", border: isFail ? "1.5px solid #e8a0a0" : "1px solid #d8d8ee", fontFamily:"inherit", lineHeight:"1.4", color: isFail ? "#7a2020" : "#333", outline:"none", minHeight:`${item.height}px`, backgroundColor: isFail ? "#fff6f6" : "#f6f6fb"}}
                      />
                    </Box>
                  </React.Fragment>
                );
              })}
            </Box>
          </Box>

          {/* 저장 버튼 */}
          <Box sx={{marginTop:"8px", display:"flex", flexDirection:"column", gap:"8px", flexShrink:0}}>
            <Button
              variant="contained" fullWidth
              disabled={!ssbData.idx || hasIspFailItem}
              sx={{height:"44px", fontSize:"14px", fontWeight:700, borderRadius:"8px", letterSpacing:"2px", backgroundColor: hasIspFailItem ? "#aaa" : "#3e36a5", boxShadow: hasIspFailItem ? "none" : "0 2px 6px rgba(62,54,165,0.35)", "&:hover":{backgroundColor: hasIspFailItem ? "#aaa" : "#2d2880"}, cursor: hasIspFailItem ? "not-allowed" : "pointer"}}
              onClick={() => handleSave('Y')}
            >
              <Box sx={{display:"flex", flexDirection:"column", alignItems:"center", gap:"2px"}}>
                <Box>적합</Box>
                {hasIspFailItem && <Box sx={{fontSize:"10px", fontWeight:600, letterSpacing:"0px", color:"#ff6b6b"}}>FAIL 항목이 있어 클릭할 수 없습니다</Box>}
              </Box>
            </Button>
            <Button
              variant="contained" fullWidth
              disabled={!ssbData.idx}
              sx={{height:"44px", fontSize:"14px", fontWeight:700, backgroundColor:"#c0392b", borderRadius:"8px", boxShadow:"0 2px 6px rgba(192,57,43,0.35)", "&:hover":{backgroundColor:"#a93226"}, letterSpacing:"2px"}}
              onClick={() => handleSave('N')}
            >부적합</Button>
            <Box sx={{marginTop:"4px"}}>
              <Box sx={{fontSize:"11px", color:"#888", marginBottom:"4px", fontWeight:600, letterSpacing:"0.5px"}}>작업 비고</Box>
              <textarea
                value={ssbData.job_reason || ''}
                onChange={(e) => setSsbData((prev:any) => ({...prev, job_reason: e.target.value}))}
                rows={1}
                placeholder="비고를 입력하세요"
                style={{width:"100%", boxSizing:"border-box", resize:"vertical", fontSize:"12px", padding:"8px", borderRadius:"6px", border:"1px solid #ddd", fontFamily:"inherit", lineHeight:"1.5", color:"#333", outline:"none"}}
              />
            </Box>
          </Box>
        </Box>

        {/* 작업 목록 */}
        <Box sx={{marginLeft:"4px", alignSelf:"flex-start", position:"sticky", top:0, display:"flex", flexDirection:"column", marginTop:"12px"}}>

          <Box sx={{display:"flex", alignItems:"center", gap:"6px", marginBottom:"6px", width:"242px", backgroundColor:"#f4f4ff", border:"1.5px solid #9090c8", borderRadius:"8px", padding:"6px 10px", boxShadow:"0 1px 4px rgba(62,54,165,0.08)"}}>
            <Box sx={{fontSize:"10px", fontWeight:700, color:"#3e36a5", flexShrink:0}}>트랙</Box>
            <Select size="small" value={track_filter} onChange={(e) => { setTrack_filter(e.target.value); setPage(1); }} sx={{flex:1, height:"22px", fontSize:"11px", fontWeight:600, backgroundColor:"#fff", "& .MuiSelect-select":{padding:"0 20px 0 6px"}, "& .MuiOutlinedInput-notchedOutline":{borderColor:"#9090c8"}}}>
              {['모두','T1','T2','T4'].map(v => <MenuItem key={v} value={v} sx={{fontSize:"11px"}}>{v}</MenuItem>)}
            </Select>
            <Box sx={{width:"1px", height:"16px", backgroundColor:"#c8c8e0", flexShrink:0}} />
            <Box sx={{fontSize:"10px", fontWeight:700, color:"#3e36a5", flexShrink:0}}>상태</Box>
            <Select size="small" value={job_yn_filter} onChange={(e) => { setJob_yn_filter(e.target.value); setPage(1); }} sx={{flex:1.4, height:"22px", fontSize:"11px", fontWeight:600, backgroundColor:"#fff", "& .MuiSelect-select":{padding:"0 20px 0 6px"}, "& .MuiOutlinedInput-notchedOutline":{borderColor:"#9090c8"}}}>
              <MenuItem value="모두" sx={{fontSize:"11px"}}>모두</MenuItem>
              <MenuItem value="미작업" sx={{fontSize:"11px"}}>미작업</MenuItem>
              <MenuItem value="Y" sx={{fontSize:"11px"}}>적합</MenuItem>
              <MenuItem value="N" sx={{fontSize:"11px"}}>부적합</MenuItem>
            </Select>
          </Box>

          <Box sx={{width:"242px", border:"1.5px solid #9090c8", borderRadius:"8px", overflow:"hidden", boxShadow:"0 2px 8px rgba(0,0,0,0.08)", maxHeight:"920px", display:"flex", flexDirection:"column"}}>
            <Box sx={{display:"flex", alignItems:"center", gap:"6px", padding:"7px 12px", backgroundColor:"#000"}}>
              <img style={{width:"16px", objectFit:"cover", borderRadius:"2px"}} src={process.env.PUBLIC_URL + '/img/ko_flag.jpg'} alt="" />
              <Box sx={{color:"#fff", fontSize:"12px", fontWeight:700, letterSpacing:"0.5px"}}>작업 목록</Box>
              {total_cnt > 0 && (
                <Box sx={{marginLeft:"auto", backgroundColor:"rgba(255,255,255,0.2)", color:"#fff", fontSize:"12px", fontWeight:700, padding:"1px 6px", borderRadius:"20px"}}>{total_cnt} 건</Box>
              )}
            </Box>

            <Box sx={{flex:1, overflowY:"auto", backgroundColor:"#fff"}}>
              {(ssbWorkList && ssbWorkList.length > 0)
                ? ssbWorkList.map((row:any, index:number) => {
                    const isSelected = ssbData && row.bmk_id === ssbData.bmk_id;
                    const statusColor = row.job_yn === "Y" ? "#27a348" : row.job_yn === "N" ? "#c0392b" : "#bbb";
                    const statusBg    = row.job_yn === "Y" ? "#f0fff4" : row.job_yn === "N" ? "#fff0ee" : "#f5f5f5";
                    const statusLabel = row.job_yn === "Y" ? "완료" : row.job_yn === "N" ? "부적합" : "미작업";
                    return (
                      <Box key={index} onClick={() => {
                        setSsbData(!row.job_yn || row.job_yn === '' ? {...row, job_reason:''} : row);
                        if (ssbData.idx !== row.idx) {
                          setIspChecklist(initIspChecklist);
                          setIspReasons(initIspReasons);
                        }
                      }} sx={{display:"flex", alignItems:"center", justifyContent:"space-between", padding:"5px 10px 5px 0", cursor:"pointer", borderLeft: isSelected ? "4px solid #3e36a5" : "4px solid transparent", backgroundColor: isSelected ? "#eeeeff" : "transparent", borderBottom:"1px solid #f0f0f4", "&:hover":{backgroundColor: isSelected ? "#eeeeff" : "#f5f5ff"}}}>
                        <Box sx={{display:"flex", alignItems:"center", gap:"2px", fontSize:"11px", fontWeight: isSelected ? 600 : 400, color: isSelected ? "#3e36a5" : "#555", minWidth:"60px"}}>
                          {index+1}. {row.bmk_id}
                        </Box>
                        <Box sx={{display:"flex", alignItems:"center", gap:"4px"}}>
                          <Box sx={{fontSize:"8px", fontWeight:600, padding:"1px 5px", borderRadius:"20px", border:`1.5px solid ${statusColor}`, color:statusColor, backgroundColor:statusBg}}>{statusLabel}</Box>
                          {(() => {
                            const cl = row.result_tf || '';
                            const failNums: number[] = [];
                            for (let i = 0; i < cl.length; i++) { if (cl[i] === 'F') failNums.push(i + 1); }
                            if (failNums.length === 0) return null;
                            const display = failNums.slice(0, 3);
                            return (
                              <Box sx={{fontSize:"10px", fontWeight:700, color:"#c0392b", flexShrink:0, lineHeight:1}}>
                                {display.join(',')}{failNums.length > 3 && '+'}
                              </Box>
                            );
                          })()}
                          {row.job_reason && <Box sx={{width:"6px", height:"6px", borderRadius:"50%", backgroundColor:"#f5c518", flexShrink:0}} />}
                        </Box>
                      </Box>
                    );
                  })
                : <Box sx={{padding:"20px", textAlign:"center", fontSize:"12px", color:"#bbb"}}>데이터 없음</Box>
              }
            </Box>

            {pagination !== undefined && (
              <Box sx={{borderTop:"1px solid #e8e8f0", padding:"4px", backgroundColor:"#fafafa"}}>
                <CustomPagination pagination={pagination} goPage={goPage} />
                <Box sx={{display:"flex", alignItems:"center", marginTop:"6px", gap:"4px"}}>
                  <TextField size="small" value={c_page} onChange={(e) => setC_page(e.target.value)} sx={{width:"80px"}} InputProps={{style:{height:"26px", fontSize:"12px"}, inputProps:{spellCheck:"false"}}} />
                  <Button variant="contained" size="small" sx={{minWidth:"40px", height:"26px", fontSize:"11px", fontWeight:700, backgroundColor:"#3e36a5", padding:"0 8px"}} onClick={() => setPage(Number(c_page))}>이동</Button>
                </Box>
              </Box>
            )}
          </Box>
        </Box>

      </Box>
    </Paper>
  );
};

export default IspEssWorkerPage;
